import './update-issuer-tier.scss'

import { notification } from 'antd'
import axios from 'axios'
import { Formik } from 'formik'
import { Form, FormItem, Select, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column, Row } from 'react-display-flex'

import { emptyCharacter } from '../../../../components/EmptyChar'
import { messages } from '../../messages'
import { IssuerTier } from '../../models'
import { instrumentTiers, tiersByInstrument, UpdateIssuerTierFormValues, updateIssuerTierValues } from './models'
import { issuerTierValidationSchema } from './validators'

interface UpdateIssuerTierProps {
  issuerId: number
  tiers: IssuerTier[]
  onSuccess?: () => void
}

export const UpdateIssuerTier = ({ issuerId, tiers, onSuccess }: UpdateIssuerTierProps) => {
  const onSubmit = async (formData: UpdateIssuerTierFormValues) => {
    try {
      await axios.put(`/issuers/${issuerId}/tiers`, formData)
      notification.success({
        message: messages.common.success,
        description: messages.update.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: messages.common.error,
        description: error.error_message || messages.update.error,
      })
    }
  }

  return (
    <>
      <Row justifyContentSpaceBetween>
        {instrumentTiers.map((instrumentCode) => (
          <dl key={`${issuerId}${instrumentCode}`}>
            <dt>{instrumentCode}</dt>
            <dd>{getTierNameByInstrumentCode({ tiers, instrumentCode })}</dd>
          </dl>
        ))}
      </Row>
      <Formik
        initialValues={updateIssuerTierValues}
        validationSchema={issuerTierValidationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values }) => (
          <Form name="update-issuer-tier">
            <FormItem name="instrumentCode" label="Instrument" required>
              <Select
                name="instrumentCode"
                placeholder="Select a Instrument"
                options={['CD', 'TD'].map((tier) => ({ value: tier, label: tier }))}
              />
            </FormItem>
            <FormItem name="tier" label="Tier" required>
              <Select
                name="tier"
                placeholder="Select the tier"
                options={
                  values?.instrumentCode
                    ? Object.keys(tiersByInstrument[values?.instrumentCode]).map((tier) => ({
                        value: tier,
                        label: tiersByInstrument[values?.instrumentCode][tier],
                      }))
                    : []
                }
              />
            </FormItem>
            <Column>
              <SubmitButton htmlType="submit" type="primary">
                Update Tier
              </SubmitButton>
            </Column>
          </Form>
        )}
      </Formik>
    </>
  )
}

const getTierNameByInstrumentCode = ({ tiers, instrumentCode }: { tiers: IssuerTier[]; instrumentCode: string }) => {
  const currentTier = tiers?.find((tier) => tier.instrumentCode === instrumentCode)?.tier

  return currentTier ? tiersByInstrument[instrumentCode][currentTier] : emptyCharacter
}
